import React, { useState, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";

const VerticalCarousel = ({ product }) => {
  const images = [
    product.product_main_image_url_large,
    product.product_image_two_url,
    product.product_image_three_url,
    product.product_image_four_url,
  ].filter(Boolean); // ✅ Remove null or undefined values

  const [selectedImage, setSelectedImage] = useState(images[0]);

  const [isHovered, setIsHovered] = useState(false);
  const [lensPosition, setLensPosition] = useState({ x: 0, y: 0 });
  const [backgroundPosition, setBackgroundPosition] = useState({ x: 0, y: 0 });
  const containerRef = useRef(null);

  const handleMouseMove = (e) => {
    const container = containerRef.current;
    if (!container) return;

    const rect = container.getBoundingClientRect();
    const lensWidth = 200; // Adjust lens size
    const lensHeight = 200;

    // Calculate lens position
    const x = e.clientX - rect.left - lensWidth / 2;
    const y = e.clientY - rect.top - lensHeight / 2;

    // Keep lens within bounds
    const maxX = rect.width - lensWidth;
    const maxY = rect.height - lensHeight;
    const clampedX = Math.max(0, Math.min(x, maxX));
    const clampedY = Math.max(0, Math.min(y, maxY));

    // Calculate background position (for zoomed area)
    const bgX = (clampedX / maxX) * 100;
    const bgY = (clampedY / maxY) * 100;

    setLensPosition({ x: clampedX, y: clampedY });
    setBackgroundPosition({ x: bgX, y: bgY });
  };


  const settings = {
    dots: false,
    lazyLoad: 'ondemand',
    infinite: images.length > 1, // ✅ Prevent infinite scroll if only one image
    speed: 500,
    slidesToShow: Math.min(images.length, 3), // ✅ Show only available images (max 3)
    slidesToScroll: 1,
    vertical: false,
    verticalSwiping: true,
    prevArrow: images.length > 1 ? <SamplePrevArrow /> : null, // ✅ Hide arrows if only one image
    nextArrow: images.length > 1 ? <SampleNextArrow /> : null,
  };

  return (
    <div style={{ width: "85%"}} className="vertical-slider">
      {/* ✅ Display the selected image at the top */}
      <div
        style={{
          textAlign: "center",
          marginBottom: "15px",
        }}
        className="product-detail-main-img"
      >
        <div
          className="image-container"
          ref={containerRef}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onMouseMove={handleMouseMove}
        >
          {/* <img
          src={selectedImage}
          alt="Selected Product"
          className="img-fluid"
          style={{
            width: "100%",
            height:"100%",
            objectFit: "cover",
            objectPosition:"Top"
          }}
        /> */}

          <img   src={selectedImage}
          alt="Selected Product" className="main-image" />
          {isHovered && (
            <div
              className="zoom-lens"
              style={{
                left: `${lensPosition.x}px`,
                top: `${lensPosition.y}px`,
                backgroundImage: `url(${selectedImage})`,
                backgroundPosition: `${backgroundPosition.x}% ${backgroundPosition.y}%`,
              }}
            />
          )}

        </div>
      </div>

      {/* ✅ Thumbnail Carousel (Show only if more than one image exists) */}
      {images.length > 1 ? (
        <Slider {...settings}>
          {images.map((image, index) => (
            <div
              key={index}
              onClick={() => setSelectedImage(image)}
              style={{
                height: "100px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                border: selectedImage === image ? "2px solid #a76d50" : "none",
              }}
              className="vertical-carousel-div"
            >
              <img src={image} alt={`Thumbnail ${index + 1}`} className="img-fluid" />
            </div>
          ))}
        </Slider>
      ) : null}
    </div>
  );
};

// ✅ Custom Previous Arrow
const SamplePrevArrow = (props) => {
  const { onClick } = props;
  return (
    <button
      onClick={onClick}
      style={{
        position: "absolute",
        top: "50%",
        left: "-22px",
        transform: "translateY(-50%)",
        background: "transparent",
        border: "none",
        cursor: "pointer",
        zIndex: 1,
      }}
    >
      <FontAwesomeIcon icon={faAngleLeft} />
    </button>
  );
};

// ✅ Custom Next Arrow
const SampleNextArrow = (props) => {
  const { onClick } = props;
  return (
    <button
      onClick={onClick}
      style={{
        position: "absolute",
        bottom: "50%",
        right: "-22px",
        transform: "translateY(50%)",
        background: "transparent",
        border: "none",
        cursor: "pointer",
        zIndex: 1,
      }}
    >
      <FontAwesomeIcon icon={faAngleRight} />
    </button>
  );
};

export default VerticalCarousel;
